//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'quickButton',

	props: {
		type: {
			type: String,
			default: 'primary'
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {}
	},

	computed: {
		
	},

	methods: {
		handleClick() {
			!this.disabled && this.$emit('on-click');
		}	
	},

	created () {

	},

	mounted () {
	

	},
}



// WEBPACK FOOTER //
// ./src/components/quickButton/quickButton.vue